import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  Panel,
  FormElement,
  Flex,
  InputText,
  FlexItem,
  Select,
  GridCell,
  Grid,
  Text,
  TruncateAndTooltip,
  TooltipUtils,
} from "mailup-web-components";
import styled from "@emotion/styled";
import iconArrow from "../../../../icons/arrow-right-blue.svg";
import iconSucces from "../../../../icons/icon-succes-circle.svg";
import iconDisable from "../../../../icons/icon-disable-circle.svg";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { previewTableState } from "Pages/ImportWizard/recoil/state/stateStep2";
import { importFileWizardState } from "Pages/ImportWizard/recoil/state/state";
import { dynamicFieldsOptionState } from "Pages/ImportWizard/recoil/state/stateStep3";

interface FieldProps {
  value: string;
  index: number;
}

const Field = ({ value, index }: FieldProps) => {
  const intl = useIntl();

  const { Rows } = useRecoilValue(previewTableState);
  const { IgnoreFirstRow, FieldMapping } = useRecoilValue(
    importFileWizardState,
  );

  const setImportFileWizardState = useSetRecoilState(importFileWizardState);
  const dynamicFieldsOption = useRecoilValue(dynamicFieldsOptionState);
  const [fieldId, setFiledId] = useState(undefined);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setValueDynamicField();
    TooltipUtils.rebuild();
  }, [FieldMapping]);

  useEffect(() => {
    TooltipUtils.rebuild();
  }, []);

  const onChangeDynamicField = (value: number) => {
    setImportFileWizardState((prev) => ({
      ...prev,
      FieldMapping: prev.FieldMapping.map((mapping) => {
        if (mapping.ColumnIndex === index) {
          return { ...mapping, FieldID: value };
        }
        if (value > 0 && mapping.FieldID === value) {
          return { ...mapping, FieldID: 0 };
        }
        return mapping;
      }),
    }));
  };

  const setValueDynamicField = () => {
    if (FieldMapping.length > 0) {
      const item = FieldMapping.find((f) => f.ColumnIndex === index);
      if (item?.FieldID !== undefined) {
        setFiledId(item.FieldID);
      } else {
        setFiledId(undefined);
      }
    } else {
      setFiledId(undefined);
    }
  };

  return (
    <Panel>
      <Flex gap="24px">
        <FlexItem flex="1">
          <FormElement
            label={`${intl.formatMessage({
              id: "Load.FileImport.Column",
            })} ${index + 1}`}
          >
            <InputText
              value={
                value && IgnoreFirstRow
                  ? value
                  : intl.formatMessage({
                      id: "Load.FileImport.HeaderNotFind",
                    })
              }
              disabled
              style={{
                color:
                  fieldId && IgnoreFirstRow && value ? "#252525" : "#B9B9B9",
              }}
            />
          </FormElement>
        </FlexItem>
        <img src={iconArrow} alt="Arrow separator" />
        <FlexItem flex="1">
          <FormElement
            label={intl.formatMessage({
              id: "Load.FileImport.DestAnagrFiledLabel",
            })}
            hint={intl.formatMessage({
              id: "Load.FileImport.DestAnagrFiledHinit",
            })}
          >
            <Select
              searchable
              // placeholder={intl.formatMessage({
              //   id: "Load.FileImport.SelectFieldPlaceholder",
              // })}
              onChange={onChangeDynamicField}
              value={fieldId}
              options={dynamicFieldsOption}
            />
          </FormElement>
        </FlexItem>
        <FlexItem flex="1">
          <Grid cols={12}>
            <GridCell span={10}>
              <FormElement
                label={intl.formatMessage({
                  id: "Load.FileImport.ExampleData",
                })}
              >
                {(!IgnoreFirstRow ? [0, 1, 2] : [1, 2, 3]).map((i) => (
                  <div key={i}>
                    {Rows[i]?.[index] ? (
                      <Text variant="light">
                        <TruncateAndTooltip text={Rows[i]?.[index]} />
                      </Text>
                    ) : (
                      <Text variant="extralight">
                        {intl.formatMessage({
                          id: "Load.FileImport.Empty",
                        })}
                      </Text>
                    )}
                  </div>
                ))}
              </FormElement>
            </GridCell>
            <GridCell span={2}>
              <Styledimg
                src={fieldId ? iconSucces : iconDisable}
                alt="state import"
                data-tip={
                  fieldId
                    ? intl.formatMessage({
                        id: "Load.FileImport.ImportActive",
                      })
                    : intl.formatMessage({
                        id: "Load.FileImport.ImportInactive",
                      })
                }
              />
            </GridCell>
          </Grid>
        </FlexItem>
      </Flex>
    </Panel>
  );
};
export default Field;

const Styledimg = styled.img` 
    position: relative;
    top: 31px;
`;
